module.exports = __webpack_public_path__ + "static/media/img-we-are.6f2273cf.png";